import React, { Component } from 'react';
import { connect } from 'react-redux';
import registrationTotal from '../../selectors/registrationTotal.selector';
import TextInput from '../../components/TextInput';

class RegistrationTotal extends Component {
  render() {
    const { total } = this.props;
    return (
      <div className="Row Row-finalTotalRow">
        <TextInput tabIndex="-1" className="Row-total Row-finalTotal" id="RTotal" tooltip="Registration Total" value={total} readOnly />
        <label tabIndex="-1" className="Row-finalTotalLabel" htmlFor="RTotal">REGISTRATION TOTAL</label>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    total: registrationTotal(state),
  };
};

export default connect(mapStateToProps)(RegistrationTotal);
